import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NotFound from '../NotFound';
import DataTable from '../DataTable';
import { setTempConfigFile } from '../../../actions';
import funcTranslateHelper from '../../../i18next/funcTranslateHelper';
import { Modal } from 'carbon-components-react';
import BuilderForm from '../FormCarbon';
import { onAdd } from './onAdd';
import { onDelete } from './onDelete';
import { onEdit } from './onEdit';
import { parseAction } from './utils';
import { uiSchema, translateSchema } from './config';
import './styles.scss';

const Actions = props => {
  const { configFile, tempConfigFile, saveTempConfigFile } = props;
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [actionToEdit, setActionToEdit] = useState();
  const [notification, setNotification] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [affectedDependencies, setAffectedDependencies] = useState({});
  const [newTempConfigFile, setNewTempConfigFile] = useState({});
  const schema = useMemo(translateSchema, []);
  const [data, setData] = useState([
    { schema, uiSchema, formData: {} },
    { schema: {}, uiSchema: {}, formData: {} }
  ]);

  const config = tempConfigFile || configFile;
  const actions = config.actions || [];
  const assetTypes = config.assetTypes;
  const rows = actions.map(e => parseAction(e, assetTypes));
  const disableBuilder = config.disableBuilder;

  const [currentStep, setCurrenStep] = useState(0);

  const headers = [
    { header: 'Nombre', key: 'name' },
    { header: 'Descripción', key: 'description' },
    { header: 'Tipo', key: 'type' },
    { header: 'Título de formulario', key: 'formAssetTitle' },
    { header: 'Tipo de Asset', key: 'asset' }
  ];

  const types = assetTypes.reduce(
    (acc, current) => {
      const { names, ids } = acc;
      ids.push(current.id);
      names.push(current.name);
      return acc;
    },
    { names: [], ids: [] }
  );
  schema.properties.asset.enum = [''].concat(types.ids);
  schema.properties.asset.enumNames = [funcTranslateHelper('Builder:Actions:form:chooseOption')].concat(types.names);

  const _next = () => {
    return currentStep < 1 && setCurrenStep(s => s + 1);
  };

  const toggleForm = () => {
    setCurrenStep(0);
    if (open) {
      setData(
        [
          { schema, uiSchema, formData: {} },
          { schema: {}, uiSchema: {}, formData: {} }
        ]
      );
      setEdit(false);
    }
    setOpen(!open);
  };

  const handleOnCLose = () => {
    setActionToEdit(undefined);
    toggleForm();
  };

  const openEdit = id => {
    const action = actions.find(action => action.id === id);
    setActionToEdit(action);
    setData(
      [
        {
          schema,
          uiSchema,
          formData: {
            id: action.id,
            name: action.name,
            description: action.description,
            type: action.actionRef.method,
            formAssetTitle: action.schema.title,
            asset: action.assetType
          }
        },
        { schema: action.schema, uiSchema: action.uiSchema, formData: {} }
      ]
    );
    toggleForm();
    setEdit(true);
  };

  if (!assetTypes || !assetTypes.length) {
    return (
      <NotFound
        title='Roles'
        subtitle='Subtitle'
        type='no-req'
        message={funcTranslateHelper('Builder.Actions.errorAssetType')}
      />
    );
  }

  if (open) {
    return (
      <BuilderForm
        onAdd={(form) => edit ? onEdit(
          form.formData,
          actionToEdit,
          currentStep,
          setActionToEdit,
          assetTypes,
          config,
          data,
          setData,
          tempConfigFile,
          setNewTempConfigFile,
          _next,
          newTempConfigFile,
          saveTempConfigFile,
          setNotification,
          open,
          toggleForm,
          setCurrenStep
        )
          : onAdd(
            form.formData,
            currentStep,
            assetTypes,
            config,
            actions,
            data,
            setData,
            actionToEdit,
            setActionToEdit,
            _next,
            saveTempConfigFile,
            setNotification,
            open,
            toggleForm)}
        onClose={handleOnCLose}
        onEdit={(form) => onEdit(
          form.formData,
          actionToEdit,
          currentStep,
          setActionToEdit,
          assetTypes,
          config,
          data,
          setData,
          tempConfigFile,
          setNewTempConfigFile,
          _next,
          newTempConfigFile,
          saveTempConfigFile,
          setNotification,
          open,
          toggleForm,
          setCurrenStep
        )}
        open
        title={funcTranslateHelper('Builder.Actions.form.titulo')}
        subtitle={funcTranslateHelper('Builder.Actions.form.subtitulo')}
        schema={data[currentStep].schema}
        uiSchema={data[currentStep].uiSchema}
        formData={edit ? data[currentStep].formData : {}}
        primaryButtonText={currentStep === data.length - 1
          ? funcTranslateHelper('Guardar') : funcTranslateHelper('Siguiente')}
        secondaryButtonText={currentStep === data.length - 1
          ? funcTranslateHelper('Atrás') : funcTranslateHelper('Cancelar')}
      />
    );
  }

  if (showModal) {
    return (
      <Modal
        className='some-class'
        hasScrollingContent={false}
        iconDescription={funcTranslateHelper(
          'Builder.Actions.modal.iconDescription'
        )}
        modalAriaLabel='A label to be read by screen readers on the modal root node'
        modalHeading={funcTranslateHelper('Builder.Actions.modal.title')}
        onRequestClose={() => {
          setAffectedDependencies({});
          setShowModal(false);
        }}
        open
        passiveModal
        primaryButtonDisabled={false}
        selectorPrimaryFocus='[data-modal-primary-focus]'
        size={undefined}
      >
        <div className='bx--modal-content__text'>
          {funcTranslateHelper('Builder.Actions.modal.message')}
          <br />
          {affectedDependencies.transitionsAffected && affectedDependencies.transitionsAffected.length > 0 && (
            <>
              <br />
              <strong>
                {funcTranslateHelper('Builder.Actions.modal.transitionTitle')}
              </strong>
              <br />
              <ul>
                {affectedDependencies.transitionsAffected.map((item, key) => (
                  <li key={key}>&emsp; - {item.nombre}</li>
                ))}
              </ul>
            </>
          )}
          <br />
          {funcTranslateHelper('Builder.Actions.modal.callToActionMessage')}
          <br />
        </div>
      </Modal>
    );
  }

  if (!rows.length) {
    return (
      <NotFound
        title={funcTranslateHelper('Builder.Actions.titulo')}
        subtitle={funcTranslateHelper('Builder.Actions.subtitulo')}
        handleOpen={toggleForm}
        notification={notification}
        message={funcTranslateHelper('Builder.Actions.newActions')}
      />
    );
  }

  return (
    <div className='data-table-container'>
      <DataTable
        title={funcTranslateHelper('Builder.Actions.titulo')}
        subtitle={funcTranslateHelper('Builder.Actions.subtitulo')}
        headers={headers}
        rows={rows}
        handleOpen={toggleForm}
        onDelete={(id) => onDelete(id, config, setAffectedDependencies, setShowModal, saveTempConfigFile, setNotification, open, toggleForm)}
        onEdit={openEdit}
        allowEdit={!disableBuilder}
        rawData={actions}
        notification={notification}
      />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    configFile: state.configFile,
    tempConfigFile: state.tempConfigFile
  };
};

const mapDispatchToProps = dispatch => {
  return {
    saveTempConfigFile: data => dispatch(setTempConfigFile(data))
  };
};

Actions.propTypes = {
  configFile: PropTypes.object.isRequired,
  tempConfigFile: PropTypes.object.isRequired,
  saveTempConfigFile: PropTypes.func.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(Actions);
